import utilsApi from './utils'

export default {
    // 经费最大入力check
    expenseCheck(itemName, vt, row, fieldName) {
        for (var item of vt.personalAttendanceExpense) {
            if (item.note == fieldName && Number(row[itemName].replace(/,/g, "")) > item.value) {
                return vt.$t('COMMON.MSG_EXPENSE_CHECK1').replace('{0}', fieldName).replace('{1}', utilsApi.decimalFormatter(item.value),)
            }
        }
        return ''
    },

    // 金額の有効性チェック
    expenseDigitsCheck(itemName, vt, row, fieldName) {
        if (itemName === 'km') {
            var regex = /^(([0-9]{0,6})\.([0-9]{0,1})$)|^([0-9]{0,6})$/
            if (!regex.test(row[itemName].replace(/,/g, ""))) {
                return vt.$t('COMMON.MSG_GOODS_INPUT_VALIDITY', { 0: vt.$t('MODULE.K0002_LBL_CATEGORY_EXPENSE'), 1: '6', 2: '1' })
            }
        } else {
            // 金額の有効性チェック
            var regex = /^([\d]{0,8})$/
            if (!regex.test(row[itemName].toString().replace(/,/g, ""))) {
                return vt.$t('COMMON.MSG_AMOUNT_VALIDITY', { 0: fieldName, 1: '8' })
            }
        }
        return ''
    },



    //经费check方法
    expensesInputCheck(itemName, vt, row, fieldName) {
        // row.trainBus = vt.gamenId == 'K_0007' ? row.transportExpenses : row.trainBus
        if (itemName === 'km') {
            var msgs = []
            if (this.expenseCheck('kmPrice', vt, row, fieldName) !== '') {
                msgs.push(this.expenseCheck('kmPrice', vt, row, fieldName))
            }

            if (row.trainBus.toString().replace(/,/g, "") > 0 && row.km.toString().replace(/,/g, "") > 0) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK3'))//入力額を再確認してください。（電車バスとガソリンが同時申請）
            }
            return msgs
        } else {
            var msgs = []
            if (this.expenseCheck(itemName, vt, row, fieldName) !== '') {
                msgs.push(this.expenseCheck(itemName, vt, row, fieldName))
            }

            if ((itemName == 'trainBus') && (row.trainBus.toString().replace(/,/g, "") > 0 && row.km.toString().replace(/,/g, "") > 0)) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK3'))//入力額を再確認してください。（電車バスとガソリンが同時申請）
            }
            if (itemName == 'driverAllowance' && row.driverAllowance.toString().replace(/,/g, "") > 0) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK5'))//入力額を再確認してください。（移動、運転手当の入力）
            }
            if ((itemName == 'moveAllowance' || itemName == 'driverAllowance') && (row.moveAllowance.toString().replace(/,/g, "") > 0 && row.driverAllowance.toString().replace(/,/g, "") > 0)) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK6'))//入力額を再確認してください。（移動手当と移動運転手当が同時申請）
            }
            if ((itemName == 'allowanceTrip' || itemName == 'tripAllowanceManager') && (row.allowanceTrip.toString().replace(/,/g, "") > 0 && row.tripAllowanceManager.toString().replace(/,/g, "") > 0)) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK7'))//入力額を再確認してください。（食事補助と出張手当の入力）
            }

            return msgs
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/validator.js